module.exports = __webpack_public_path__ + "svg/check-mark.8045b6102ab382b3e05e39752904bc67.svg";